import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8dada8ee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=8dada8ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dada8ee",
  null
  
)

export default component.exports